// removed by extract-text-webpack-plugin
module.exports = {"search":"_1hdoGfOWf vUrsJl1Yt","add-new-button":"_1UsGmvm3y _3JYjfkm02 Xua7s1qyX","labelled-checkbox":"_2TEu3R3dE _3JYjfkm02"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/setupform-form/field/venue-search/venue-search-container.css
 ** module id = 2168
 ** module chunks = 0
 **/